import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bonusomat-odometer__letter-odometer odometer-auto-theme" }
const _hoisted_2 = { class: "bonusomat-odometer__odometer-inside" }
const _hoisted_3 = { class: "odometer-digit" }
const _hoisted_4 = { class: "odometer-digit-inner" }
const _hoisted_5 = { class: "odometer-ribbon" }
const _hoisted_6 = { class: "odometer-ribbon-inner" }

import { computed, onMounted, ref, watch } from "vue";
import Odometer from "odometer";
import { useKeenSlider } from "keen-slider/vue.es";
import { onViewportEnter } from "@sazka/utils/viewport-enter";

const oneSlideChangeDuration = 240;
const slidesCount = 4;

export default /*@__PURE__*/_defineComponent({
  __name: 'time-counter',
  props: {
    remainingSeconds: {}
  },
  setup(__props: any) {

const props = __props;

const bonusomatOdometer = ref<HTMLElement>();
const odometerTensRef = ref<HTMLElement | null>(null);
const odometerOnesRef = ref<HTMLElement | null>(null);

const [sliderContainer, slider] = useKeenSlider<HTMLDivElement>({
    selector: ".odometer-value--unit",
    vertical: true,
    drag: false,
    mode: "free-snap",
    slides: {
        perView: 1,
    },
});

const getOnes = (val: number) => val % 10;
const getTens = (val: number) => Math.floor(val / 10);

const getValueAndUnit = (seconds: number): [number, number] => {
    const days = Math.floor(seconds / 86400);
    if (days > 0) {
        return [days, 3];
    }

    const time = new Date(seconds * 1000);

    const hours = time.getUTCHours();
    if (hours > 0) {
        return [hours, 2];
    }

    const minutes = time.getUTCMinutes();
    if (minutes > 0) {
        return [minutes, 1];
    }

    return [time.getUTCSeconds(), 0];
};

const timeSplitted = computed(() => {
    const [value, unit] = getValueAndUnit(props.remainingSeconds);

    return [getTens(value), getOnes(value), unit];
});

const odometerTens = computed(() => timeSplitted.value[0]);
const odometerOnes = computed(() => timeSplitted.value[1]);
const odometerUnit = computed(() => timeSplitted.value[2]);

let hasInitialSlidingCompleted = false;
const oneRoundAnimationSettings = computed(() => {
    return { duration: oneSlideChangeDuration * slidesCount, easing: (t) => (t -= 1) * t * t + 1 };
});

watch(odometerTens, (newValue) => {
    odometerTensRef.value.innerText = newValue.toString();
});
watch(odometerOnes, (newValue) => {
    odometerOnesRef.value.innerText = newValue.toString();
});
watch(odometerUnit, (newValue) => {
    if (hasInitialSlidingCompleted) {
        slider.value.moveToIdx(newValue, true, oneRoundAnimationSettings.value);
    }
});

onMounted(() => {
    onViewportEnter(bonusomatOdometer.value).then(() => {
        const odoTens = new Odometer({
            el: odometerTensRef.value,
            value: odometerTens.value,
            duration: 700,
        });

        const odoOnes = new Odometer({
            el: odometerOnesRef.value,
            value: odometerOnes.value,
            duration: 700,
        });

        odoTens.render();
        odoOnes.render();
    });

    setTimeout(() => {
        slider.value.moveToIdx(odometerUnit.value, true, oneRoundAnimationSettings.value);
        hasInitialSlidingCompleted = true;
    }, 2000);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "bonusomat-odometer",
    ref_key: "bonusomatOdometer",
    ref: bonusomatOdometer
  }, [
    _createElementVNode("span", {
      ref_key: "odometerTensRef",
      ref: odometerTensRef
    }, null, 512),
    _createElementVNode("span", {
      ref_key: "odometerOnesRef",
      ref: odometerOnesRef
    }, null, 512),
    _createElementVNode("span", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, [
                _createElementVNode("span", {
                  class: "bonusomat-odometer__letter",
                  ref_key: "sliderContainer",
                  ref: sliderContainer
                }, _cache[0] || (_cache[0] = [
                  _createElementVNode("span", { class: "odometer-value odometer-value--unit" }, "s", -1),
                  _createElementVNode("span", { class: "odometer-value odometer-value--unit" }, "m", -1),
                  _createElementVNode("span", { class: "odometer-value odometer-value--unit" }, "h", -1),
                  _createElementVNode("span", { class: "odometer-value odometer-value--unit" }, "d", -1)
                ]), 512)
              ])
            ])
          ])
        ])
      ])
    ])
  ], 512))
}
}

})